import { InputGroup, InputGroupAddon, InputGroupInput } from "@/components/ui/baseUi/input-group"
import { cn } from "@/modules/lib/utils"
import ExploreTraining from "@images/exporeBeyondTrainingDarkTheme.png"
import {
  BoxExploreB2BProgramsList,
  BoxExploreB2BProgramsListSkeleton,
} from "@modules/boxB2BProgram/components/boxExploreB2BProgramsList"
import { word } from "@modules/core/utils/i18n"
import useDebounce from "@modules/hooks/useDebounce"
import { Search, X } from "lucide-react"
import { Suspense, useState } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorView } from "@/components/ui/layout/error/errorView"

type BoxExploreB2BProgramsLayoutProps = {
  className?: string
} & React.ComponentProps<"div">

export function BoxExploreB2BProgramsLayout({ className, ...props }: BoxExploreB2BProgramsLayoutProps) {
  const [searchTerms, setSearchTerms] = useState("")

  const debouncedSearchTerms = useDebounce(searchTerms, 300)

  const clearSearch = () => {
    setSearchTerms("")
  }

  return (
    <div className={cn("flex flex-col justify-between gap-6 px-4 pt-18", className)} {...props}>
      <div className="flex w-full justify-center">
        <img src={ExploreTraining} className="h-auto max-w-100" />
      </div>

      <div className="mt-8 flex w-full">
        <InputGroup>
          <InputGroupInput
            placeholder={word("explore.search_placeholder")}
            onChange={(e) => setSearchTerms(e.currentTarget.value)}
            value={searchTerms}
          />
          <InputGroupAddon align="inline-start">
            <Search />
          </InputGroupAddon>
          {searchTerms && (
            <InputGroupAddon align="inline-end" onClick={clearSearch}>
              <X color="currentColor" width={14} height={14} className="cursor-pointer text-textDefault-body" />
            </InputGroupAddon>
          )}
        </InputGroup>
      </div>

      <ErrorBoundary fallback={<ErrorView />}>
        <Suspense fallback={<BoxExploreB2BProgramsListSkeleton />}>
          <BoxExploreB2BProgramsList searchTerms={debouncedSearchTerms} />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
